module.exports = __webpack_public_path__ + "static/media/bg-1.78ed2040.jpg";